import { Component } from 'react';

/* A render error in one page must not blank the whole app (it used to leave a
 * black screen). The bottom navigation stays outside this boundary, and the
 * error clears as soon as the route changes. Errors caught here never reach
 * window.onerror in production, so they are handed to ErrorMonitor directly. */
export default class PageErrorBoundary extends Component {
    state = { error: null, key: this.props.resetKey };

    static getDerivedStateFromError(error) { return { error }; }

    static getDerivedStateFromProps(props, state) {
        return props.resetKey !== state.key ? { error: null, key: props.resetKey } : null;
    }

    componentDidCatch(error) {
        window.dispatchEvent(new CustomEvent('gd:client-error', { detail: { message: error?.message, source: 'render' } }));
    }

    render() {
        if (!this.state.error) return this.props.children;
        const da = (this.props.locale || document.documentElement.lang || '').startsWith('da');
        return (
            <section role="alert" className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-6 text-center text-brand-ink">
                <h2 className="font-serif text-2xl">{da ? 'Siden kunne ikke vises' : 'This page could not be shown'}</h2>
                <p className="text-sm text-brand-ink2 max-w-sm">{da
                    ? 'Dine data er uændrede. Fejlen er sendt til os. Prøv at genindlæse, eller gå til en anden side i menuen.'
                    : 'Your data is unchanged. The error has been reported. Try reloading, or open another page from the menu.'}</p>
                <button type="button" className="rounded-full bg-brand-green text-white px-5 py-2.5" onClick={() => window.location.reload()}>
                    {da ? 'Genindlæs' : 'Reload'}
                </button>
            </section>
        );
    }
}
